// Mock data for MyBusinessAdPro

export const businessTypes = [
  { id: 'takeaway', label: 'Takeaway / Restaurant', emoji_icon: 'UtensilsCrossed' },
  { id: 'beauty', label: 'Beauty Salon / Spa', emoji_icon: 'Sparkles' },
  { id: 'plumbing', label: 'Plumbing / Trades', emoji_icon: 'Wrench' },
  { id: 'retail', label: 'Retail Shop', emoji_icon: 'ShoppingBag' },
  { id: 'fitness', label: 'Gym / Fitness', emoji_icon: 'Dumbbell' },
  { id: 'cleaning', label: 'Cleaning Services', emoji_icon: 'Sparkle' },
  { id: 'automotive', label: 'Automotive / Garage', emoji_icon: 'Car' },
  { id: 'professional', label: 'Professional Services', emoji_icon: 'Briefcase' },
  { id: 'other', label: 'Other', emoji_icon: 'Building2' },
];

export const tones = [
  { id: 'friendly', label: 'Friendly & Warm' },
  { id: 'professional', label: 'Professional' },
  { id: 'playful', label: 'Playful & Fun' },
  { id: 'urgent', label: 'Urgent / Limited Offer' },
  { id: 'luxury', label: 'Premium / Luxury' },
  { id: 'local', label: 'Local & Community' },
];

export const platforms = [
  { id: 'facebook', label: 'Facebook', icon: 'Facebook' },
  { id: 'instagram', label: 'Instagram', icon: 'Instagram' },
  { id: 'both', label: 'Both Meta Platforms', icon: 'Globe' },
];

export const heroImages = {
  cafe: 'https://images.unsplash.com/photo-1753351052617-62818ffc9173?w=1200&q=80',
  florist: 'https://images.pexels.com/photos/5414060/pexels-photo-5414060.jpeg?w=800&q=80',
  apron: 'https://images.unsplash.com/photo-1687422808248-f807f4ea2a2e?w=800&q=80',
  grocery: 'https://images.pexels.com/photos/8475169/pexels-photo-8475169.jpeg?w=800&q=80',
  socials: 'https://images.unsplash.com/photo-1683721003111-070bcc053d8b?w=800&q=80',
  analytics: 'https://images.unsplash.com/photo-1622782914767-404fb9ab3f57?w=800&q=80',
};

export const features = [
  {
    icon: 'Sparkles',
    title: 'AI-Generated Ad Copy',
    description: 'Just describe your business or offer — our AI writes scroll-stopping ads tailored to your audience.',
  },
  {
    icon: 'Image',
    title: 'Visual Generation',
    description: 'Generate eye-catching ad imagery instantly, or upload your own photos and we\'ll style them.',
  },
  {
    icon: 'Target',
    title: 'Local Audience Focus',
    description: 'Hyper-local content crafted to attract customers right in your neighbourhood.',
  },
  {
    icon: 'ShieldCheck',
    title: 'UK Compliant',
    description: 'Every ad is checked for UK ASA advertising standards before publishing.',
  },
  {
    icon: 'Save',
    title: 'Save & Reuse Campaigns',
    description: 'Build a library of winning ads. Edit, remix and re-launch anytime.',
  },
  {
    icon: 'Zap',
    title: 'Meta-Ready in Seconds',
    description: 'Post directly to Meta Ads Manager and control your budget from there.',
  },
];

export const testimonials = [
  {
    name: 'Sarah Mitchell',
    business: 'Bloom & Petal Florists, Leeds',
    quote: 'Mother\'s Day was our biggest weekend ever. The AI nailed the tone — felt like a real local florist wrote it.',
    rating: 5,
  },
  {
    name: 'Raj Patel',
    business: 'Spice Garden Takeaway, Manchester',
    quote: 'I run a 2-person kitchen. No time for marketing. Now I post 3 ads a week in 5 minutes each. Orders up 40%.',
    rating: 5,
  },
  {
    name: 'Emma Thompson',
    business: 'Glow Beauty Bar, Brighton',
    quote: 'Booked out for 3 weeks straight after one Instagram ad. Saved me £400 I would\'ve paid an agency.',
    rating: 5,
  },
];

export const sampleAds = [
  {
    id: '1',
    business: 'The Crusty Loaf Bakery',
    type: 'takeaway',
    headline: 'Wake Up to Warm Sourdough — Fresh from Our Oven by 7am',
    body: 'Made by hand, baked overnight, ready when you are. Pop into The Crusty Loaf this Saturday for our weekend special: any sourdough loaf + a flat white for just £6. Tag a friend you\'d share a slice with.',
    cta: 'Order Now',
    hashtags: '#LeedsFoodie #SourdoughLover #SupportLocal',
    platform: 'instagram',
    createdAt: '2025-07-20',
    image: 'https://images.pexels.com/photos/5414060/pexels-photo-5414060.jpeg?w=600&q=80',
  },
  {
    id: '2',
    business: 'QuickFix Plumbing',
    type: 'plumbing',
    headline: 'Burst Pipe? We\'re On Your Street in 60 Minutes',
    body: 'Local Manchester plumbers, available 24/7. No call-out fee for jobs over £80. Gas Safe registered & fully insured. Save our number — you\'ll be glad you did.',
    cta: 'Book a Plumber',
    hashtags: '#ManchesterPlumber #EmergencyPlumber #GasSafe',
    platform: 'facebook',
    createdAt: '2025-07-18',
    image: 'https://images.unsplash.com/photo-1687422808248-f807f4ea2a2e?w=600&q=80',
  },
];

export const pricingPlans = [
  {
    id: 'starter',
    name: 'Starter',
    price: 9,
    period: 'month',
    description: 'For solo owners testing the waters',
    features: [
      '1 business profile',
      '3 AI-generated ads per month',
      'Ad copy generation',
      'Standard image library',
      'Save up to 25 campaigns',
      'UK compliance auto-check',
    ],
    cta: 'Start 7-Day Trial',
    popular: false,
  },
  {
    id: 'pro',
    name: 'Pro',
    price: 19,
    period: 'month',
    description: 'For growing local businesses',
    features: [
      '1 business profile',
      'Unlimited AI ad generation',
      'AI image generation (Nano Banana)',
      'Upload your own media',
      'UK compliance auto-check',
      'Unlimited saved campaigns',
      'Priority support',
    ],
    cta: 'Start 7-Day Trial',
    popular: true,
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    price: 49,
    period: 'month',
    description: 'For teams and larger businesses',
    features: [
      'Everything in Pro',
      'Up to 5 business profiles',
      'White-label PDF exports',
      'Team seats (up to 5)',
      'Dedicated account manager',
    ],
    cta: 'Start 7-Day Trial',
    popular: false,
  },
];

export const faqs = [
  {
    q: 'Do I need any marketing experience to use this?',
    a: 'Not at all. Just describe your business or what you want to promote in plain English — our AI handles the creative writing, image suggestions, and compliance checks.',
  },
  {
    q: 'Are the ads compliant with UK advertising law?',
    a: 'Yes. Every generated ad is auto-checked against UK ASA (Advertising Standards Authority) guidelines, including misleading claims, pricing transparency, and prohibited language.',
  },
  {
    q: 'Can I post directly to Facebook and Instagram?',
    a: 'You can copy ads with one click and paste them into Meta Ads Manager. Direct API publishing is on our roadmap. You manage your ad budget through Meta\'s portal.',
  },
  {
    q: 'What if I have my own product photos?',
    a: 'Upload them! You can use your own images, or let our AI generate fresh visuals for each campaign — or mix both.',
  },
  {
    q: 'Can I cancel anytime?',
    a: 'Yes. No long contracts. Cancel from your dashboard with one click.',
  },
  {
    q: 'Do you support businesses outside the UK?',
    a: 'Yes — anyone can use the platform. Compliance auto-checks are tuned for UK ASA rules; international users can disable this in settings.',
  },
];

export const stats = [
  { value: '12,400+', label: 'Ads Generated' },
  { value: '850+', label: 'UK Businesses' },
  { value: '4.9/5', label: 'Average Rating' },
  { value: '40%', label: 'Avg. Sales Lift' },
];

// Mocked AI generation
export const generateMockAd = (brief, businessType, tone, platform) => {
  const hooks = [
    'Stop scrolling — your neighbourhood just got better.',
    'Local. Honest. Brilliant.',
    'The secret your street has been waiting for.',
    'You\'ve walked past it a hundred times. Today\'s the day.',
    'Made with care, just down the road.',
  ];
  const ctas = ['Book Now', 'Order Today', 'Get a Quote', 'Visit Us', 'Save Your Spot', 'Claim Offer'];
  const hook = hooks[Math.floor(Math.random() * hooks.length)];
  const cta = ctas[Math.floor(Math.random() * ctas.length)];

  return {
    headline: hook,
    body: `${brief.slice(0, 80)}${brief.length > 80 ? '…' : ''}\n\nWhether you\'re after quality, speed or a friendly local face — we\'ve got you. Trusted by your neighbours, recommended by friends. Pop in, ring up, or message us today and see why locals keep coming back.`,
    cta,
    hashtags: '#SupportLocal #SmallBusiness #LocalLove #UKBusiness',
    platform,
    complianceCheck: {
      passed: true,
      notes: ['No misleading claims detected', 'Pricing language compliant', 'Suitable for general audiences'],
    },
    createdAt: new Date().toISOString().split('T')[0],
  };
};
